"use client";

import { useLeadModalStore } from "@/stores/useLeadModalStore";
import { ArrowRight } from "lucide-react";
import { useT } from "@/hooks/useT";

export default function FinalCTASection() {
  const t = useT();
  const { open } = useLeadModalStore();

  return (
    <section
      className="max-w-7xl mx-4 sm:mx-auto my-16 sm:my-32 px-4 sm:px-8 md:px-16 py-12 sm:py-20 bg-gray-900 dark:bg-[#18181D] rounded-[5px] border border-gray-800 dark:border-[#1A1A1A]"
      aria-labelledby="cta-heading"
    >
      <div className="flex flex-col items-center justify-between gap-6 sm:gap-10 md:flex-row">
        <div className="text-center md:text-left md:max-w-lg">
          <h2
            id="cta-heading"
            className="mb-3 sm:mb-4 text-2xl sm:text-3xl font-monument font-bold leading-tight text-white md:text-4xl"
          >
            {t("finalCta.headline")}
          </h2>
          <p className="text-gray-400 font-satoshi mt-3 sm:mt-5 text-base sm:text-lg leading-relaxed">
            {t("finalCta.subtitle.before")}{" "}
            <strong className="text-white">{t("finalCta.subtitle.bold1")}</strong> {t("finalCta.subtitle.middle")}{" "}
            <strong className="text-white">{t("finalCta.subtitle.bold2")}</strong>. {t("finalCta.subtitle.after")}
          </p>
        </div>

        <div className="flex flex-col items-center gap-4 text-center md:text-right md:items-end">
          <button
            onClick={open}
            aria-label="Start Polymarket copy trading with FrenFlow bot"
            className="inline-flex items-center gap-2 bg-white text-gray-900 text-base font-inter-tight font-bold px-6 py-3 rounded-[5px] hover:bg-gray-100 transition-colors"
          >
            {t("finalCta.cta")}
            <ArrowRight className="w-4 h-4" />
          </button>

          <p className="text-gray-500 font-satoshi text-xs">{t("finalCta.noCard")}</p>

          <p className="text-sm font-satoshi font-medium text-gray-400 mt-2">
            {t("finalCta.trusted")}
          </p>
        </div>
      </div>
    </section>
  );
}
